import type { SVGProps } from 'react';

const SvgNewFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 16H14.11L10.28 11.3H10.21V16H7.99V8H9.91L13.7 12.7H13.78V8H16V16Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgNewFilled;
